import costumes from "./resource.json";
const existInLibrary = (id) => {
  return costumes.some((item) => {
    return item.startsWith(id)
  })
}

export {
  existInLibrary
}